<style lang="sass" scoped>
  @import '../../../sass/variables'

  .stats
    color: #3B334A
    margin: 30px 0
    font-weight: 300

    a
      text-decoration: none
      display: flex
      flex-direction: column
      align-items: flex-start
      justify-content: center

    .stat
      max-width: 280px
      max-width: 25%
      font-size: 13px
      padding: 0 15px
      display: flex
      justify-content: center
      align-items: center

      .how
        font-size: 1rem
        font-weight: 600
        line-height: 125%
        color: $salesflow-font-gray

      .details
        display: flex
        flex-direction: row
        align-items: flex-start
        justify-content: center

      h3
        padding-top: 0
        font-size: 3rem
        line-height: 120%
        font-weight: 700

      .what
        max-width: 140px
        margin-top: 0.5rem
        font-size: 0.75rem
        font-weight: 400
        line-height: 130%
        color: $salesflow-font-dark

</style>

<template>
  <div class="stats">
    <div
      class="text-center"
      v-if="loading"
    >
      <i class="fa fa-circle-o-notch fa-spin" />
    </div>
    <div
      class="row"
      v-else
    >
      <div
        class="stat col-3"
        v-for="(stat, index) in data.stats"
        :key="index"
      >
        <a :href="stat.href">
          <div class="how">{{ __(stat.how) }}</div>
          <div class="details">
            <h3 :style="{ color: stat.color }">{{ stat.value | number(0) }}</h3>
            <div
              class="what ml-2"
              v-html="__(stat.what)"
            />
          </div></a>
      </div>
    </div>
  </div>
</template>

<script>
import Widget from '../../mixins/widget';

export default {
  props: ['user', 'range', 'imports'],

  mixins: [Widget],

  data () {
    return {
      name: 'general.stats',
      loading: true,
      error: false,
      data: {},
    };
  },
};
</script>
